import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALITEMS_LOAD_BY_TRIAL_ID,

    ITrialItemsLoadByTrialIdAction,
    ITrialItemLoadFailureAction,
    ITrialItemLoadSuccessAction,

    LoadSuccess,
    LoadFailure,
    ITrialItemCreateSuccessAction,
    ITrialItemCreateFailureAction,
    ITrialItemCreateAction,
    ITrialItemSaveSuccessAction,
    ITrialItemSaveFailureAction,
    ACTION_TRIALITEM_SAVE,
    ITrialItemSaveAction,
    SaveFailure,
    SaveSuccess,
    ACTION_TRIALITEM_CREATE,
    CreateSuccess,
    CreateFailure,
    ACTION_TRIALITEM_LOAD_BY_ID,
    ITrialItemLoadByIdAction,

} from "../actions/trialItem";
import { trialItemApi } from "../services/trialItems";


export const
    getTrialItemByIdEpic = (action$): Observable<ITrialItemLoadSuccessAction | ITrialItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEM_LOAD_BY_ID)
            .mergeMap((action: ITrialItemLoadByIdAction) => {
                return trialItemApi
                    .getTrialItemById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialItem, undefined, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialItemsByTrialIdEpic = (action$): Observable<ITrialItemLoadSuccessAction | ITrialItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMS_LOAD_BY_TRIAL_ID)
            .mergeMap((action: ITrialItemsLoadByTrialIdAction) => {
                return trialItemApi
                    .getTrialItemsByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialItems, response.trialItemCategories, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialItemEpic = (action$): Observable<ITrialItemSaveSuccessAction | ITrialItemSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEM_SAVE)
            .mergeMap((action: ITrialItemSaveAction) => {
                return trialItemApi
                    .setTrialItem(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialItem, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialItemEpic = (action$): Observable<ITrialItemCreateSuccessAction | ITrialItemCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEM_CREATE)
            .mergeMap((action: ITrialItemCreateAction) => {
                return trialItemApi
                    .createTrialItem(action.trialId)
                    .map(response =>
                        CreateSuccess(response.trialItem, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }